import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import PageWrapper from "Pages/@PageWrapper"
import { HOME_ROUTES } from "@constants"
import { userData } from "@signals"
import { Grid } from "@mui/material"
import SearchAnalyticsHomeCards from "Pages/Main/Home/Cards"
import SearchAnalyticsHomePieChart from "Pages/Main/Home/PieChart"
import SearchAnalyticsHomeColumnsChart from "Pages/Main/Home/ColumnChart"
import SearchAnalyticsSummaryTable from "Pages/Main/Home/SummaryTable"
import ReportsHomeTable from "Pages/Main/Home/ReportsTable"
import VirtualTourButton, { TourOverlay } from "Pages/Main/Home/VirtualTour"

export default function HomePage() {
	const [tourActive, setTourActive] = useState(false)

	return <PageWrapper
		head={`DS Rentacar | ${HOME_ROUTES.TITLE}`}
		title={HOME_ROUTES.TITLE}
		subtitle={`Welcome, ${userData.value.username}`}
		actions={<VirtualTourButton onClick={() => setTourActive(true)} />}
	>
		<Grid container spacing={2}>
			<Grid item xs={2}>
				<SearchAnalyticsHomeCards/>
			</Grid>
			<Grid item xs={5}>
				<SearchAnalyticsHomePieChart/>
			</Grid>
			<Grid item xs={5}>
				<SearchAnalyticsHomeColumnsChart/>
			</Grid>
			<Grid item xs={6}>
				<SearchAnalyticsSummaryTable/>
			</Grid>
			<Grid item xs={6}>
				<ReportsHomeTable/>
			</Grid>
		</Grid>
		{tourActive && createPortal(
			<TourOverlay onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
